import { useState } from "react"

export const useLoader = (initState = false) => {
    const [isLoading, setIsLoading] = useState(initState)
    const toggleLoading = () => setIsLoading(s => !s);
    const disabledLoading = () => setIsLoading(false);
    const enableLoading = () => setIsLoading(true);

    return { isLoading, toggleLoading, disabledLoading, enableLoading }
}